export default (number, currency = "USD") => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    maximumSignificantDigits: 3,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
};
